module.exports = __webpack_public_path__ + "media/images/products/category/3-d1c3b64903654f13ee0c5d610ff2bcd2.jpg";